import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import { RouterProvider as CfaRouterProvider } from '@cfa/react-core';

/**
 * One CFA Design System (@cfa/react-core) router bridge for the whole app, so
 * plugins built on react-core (Spark today) don't each mount their own. The
 * matching stylesheet is imported once in `src/index.tsx` next to the tokens.
 */
function CfaDesignSystemProvider({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  return <CfaRouterProvider navigate={navigate}>{children}</CfaRouterProvider>;
}

const cfaDesignSystemRootWrapper = AppRootWrapperBlueprint.make({
  name: 'cfa-design-system',
  params: { component: CfaDesignSystemProvider },
});

export const cfaDesignSystemModule = createFrontendModule({
  pluginId: 'app',
  extensions: [cfaDesignSystemRootWrapper],
});
